import FetchBase from '../Api/FetchBase'
import {
  DEFAULT_PAGE_START,
  DEFAULT_PER_PAGE_RECORD,
  API_ENDPOINTS,
  DISCOUNT_TYPE,
  COOKIE_SET_TIMER,
} from '../Utils/constants'
import { observable, action } from 'mobx'
import { getUtcUnixDate } from '../Utils/rules'
import { generateFormData } from '../Utils/helpers'
import { COOKIE_STOAGE } from '../Utils/Storage'

export default class CustomersStore extends FetchBase {
  @observable currentOrganization = {}

  @observable ordering = undefined
  @observable orderingBy = undefined
  @observable orgfSelectedDateChoice = undefined
  @observable orgfAllFilters = {}

  @observable orgSearchText = ''
  @observable orgPageNo = DEFAULT_PAGE_START
  @observable organizationsPageLimit = DEFAULT_PER_PAGE_RECORD
  @observable organizations = []
  @observable totalOrganizations = 0
  @observable organizationsLoader = false
  @observable updateOrganizationByIdLoader = false

  @observable myAllOrganizationsDropdownLoader = false
  @observable myAllOrganizationsDropdown = []
  @observable allOrganizationDropdownList = []
  @observable allOrganizationActiveDropdownList = []
  @observable allOrganizationInActiveDropdownList = []
  @observable allCustomersDropdownList = []

  @observable allOrgOwnersDropdown = []
  @observable resellerDropdownOrganization = []

  @observable myOrganizations = []

  @observable editOrganizationData = observable({
    organization: observable({}),
    users: observable([]),
  })

  @action.bound
  resetEditData = () => {
    this.editOrganizationData = observable({
      organization: observable({}),
      users: observable([]),
    })
  }

  @observable addOrganizationData = observable({
    organization: observable({}),
    users: observable([]),
  })

  @observable deleteCustomerLoader = false
  @observable addOrganizationModalLoader = false
  //End
  @observable allPosibileStatus = []

  @action.bound
  resetAddCustomerForm = () => {
    this.addCustomerCurrentTab = 1
    this.addOrganizationData = observable({
      organization: {},
      users: observable([]),
    })
    this.addOrganizationModalLoader = false
  }

  // Organization

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  setFilters = (filters = {}) => {
    this.orgfAllFilters = filters
  }

  @action.bound
  setSelectedDateChoice = (value = undefined) => {
    this.orgfSelectedDateChoice = value
  }

  @action.bound
  setCompanySearchText = (value = '') => {
    this.orgSearchText = value
  }

  @action.bound
  setCustomersPage = (value = DEFAULT_PAGE_START) => {
    this.orgPageNo = value
  }

  getFilterObjectsForOrganization = () => {
    let options = {}
    let keys = Object.keys(this.orgfAllFilters || {})
    for (let filter of keys) {
      if (this.orgfAllFilters[filter] !== undefined) {
        options[filter] = this.orgfAllFilters[filter]
      }
    }
    if (this.orgfSelectedDateChoice) {
      let dateFilter = getUtcUnixDate(this.orgfSelectedDateChoice, {
        start: options['startDate'],
        end: options['endDate'],
      })
      options['startDate'] = dateFilter.start
      options['endDate'] = dateFilter.end
    } else {
      delete options['startDate']
      delete options['endDate']
    }

    delete options['choice']

    if (this.ordering) {
      options['ordering'] = this.ordering
      options['orderBy'] = this.orderingBy
    }

    return options
  }

  @action.bound
  getAllOrganizations = async (signal) => {
    try {
      this.organizationsLoader = true
      let options = this.getFilterObjectsForOrganization()

      this.orgSearchText && (options['search'] = this.orgSearchText)
      this.orgPageNo && (options['pageNo'] = Math.max(this.orgPageNo - 1, 0))
      let response = await this.post(
        API_ENDPOINTS.GET_ORG_LIST,
        options,
        signal
      )

      if (response.status) {
        this.organizations = response.data.Organizations || []
        this.resellerDropdownOrganization = response.data?.resellerDropdown
        this.allOrgOwnersDropdown = response.data?.ownerDropdown
        this.totalOrganizations = response.data.total || 0
        return true
      } else {
        this.organizations = []
        return false
      }
    } catch (err) {
      console.log(err, 137)
      this.organizations = []
      return false
    } finally {
      this.organizationsLoader = false
    }
  }

  @action.bound
  getAllOrganizationsForReseller = async (value, signal) => {
    try {
      this.organizationsLoader = true
      let options = this.getFilterObjectsForOrganization()

      this.orgSearchText && (options['search'] = this.orgSearchText)
      this.orgPageNo && (options['pageNo'] = Math.max(this.orgPageNo - 1, 0))
      let response = await this.post(
        API_ENDPOINTS.GET_ORG_LIST,
        {
          resellerIds: [value],
          ...options,
        },
        signal
      )

      if (response.status) {
        this.organizations = response.data.Organizations || []
        this.resellerDropdownOrganization = response.data?.resellerDropdown
        this.allOrgOwnersDropdown = response.data?.ownerDropdown
        this.totalOrganizations = response.data.total || 0
        return true
      } else {
        this.organizations = []
        return false
      }
    } catch (err) {
      console.log(err, 137)
      this.organizations = []
      return false
    } finally {
      this.organizationsLoader = false
    }
  }

  @action.bound
  getAllOrganizationExportData = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getFilterObjectsForOrganization()

      this.orgSearchText && (options['search'] = this.orgSearchText)
      this.orgPageNo && (options['pageNo'] = Math.max(this.orgPageNo - 1, 0))
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_ORG_LIST, options)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getResellerOrganizationExportData = async ({
    exportFileType = 'csv',
    resellerIds,
  } = {}) => {
    try {
      let options = this.getFilterObjectsForOrganization()
      this.orgSearchText && (options['search'] = this.orgSearchText)
      this.orgPageNo && (options['pageNo'] = Math.max(this.orgPageNo - 1, 0))
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_ORG_LIST, {
        resellerIds: [resellerIds],
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addOrganizationDetails = async (details = {}) => {
    try {
      this.addOrganizationModalLoader = true
      const {
        addressLine1,
        city,
        contactNumber,
        country,
        description,
        email,
        firstName,
        lastName,
        logo,
        organizationName,
        role,
        state,
        title,
        userCity,
        userCountry,
        userState,
        zipcode,
        discountType = DISCOUNT_TYPE.PERCENTAGE,
        discountStartDate,
        discountEndDate,
        discountValue,
        isFeeWaived,
        phoneExtension,
        commission,
        resellerId,
      } = details
      let response = await this.postWithFormData(
        API_ENDPOINTS.ADD_ORG,
        generateFormData({
          addressLine1,
          city,
          contactNumber,
          country,
          description,
          email,
          firstName,
          lastName,
          logo,
          organizationName,
          role,
          state,
          title,
          userCity,
          userCountry,
          userState,
          zipcode,
          discountType,
          discountStartDate,
          discountEndDate,
          discountValue,
          isFeeWaived,
          phoneExtension,
          commission,
          resellerId,
        })
      )
      if (response.status) {
        this.addOrganizationData.organization = observable(response.data)
        return [true, response.data]
      } else {
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.addOrganizationModalLoader = false
    }
  }

  @action.bound
  addLocallyOrganizationDetails = (values) => {
    this.totalOrganizations = this.totalOrganizations + 1
    this.organizations = [values, ...this.organizations]
  }

  @action.bound
  getOrganizationById = async (id) => {
    try {
      let responseOrg = await this.get(API_ENDPOINTS.GET_ORG_BY_ID, {
        id: id,
      })
      if (responseOrg.status) {
        const { data } = responseOrg
        this.editOrganizationData = observable({
          organization: observable(data),
          users: observable([]),
        })
        this.currentOrganization = data
        return [true, data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resetFilterForm = () => {
    this.orgfSelectedDateChoice = undefined
    this.orgfAllFilters = {}
  }

  @action.bound
  updateOrganizationById = async (id, values, isMyOrg) => {
    try {
      this.updateOrganizationByIdLoader = true
      const {
        organizationName,
        logo,
        description,
        country,
        city,
        state,
        addressLine1,
        zipcode,
        timezone,
        discountType = DISCOUNT_TYPE.PERCENTAGE,
        discountStartDate,
        discountEndDate,
        discountValue,
        deletelogo,
        isFeeWaived,
        resellerId,
        commission,
      } = values
      // isMyOrg true then is from user request
      let response = await this.postWithFormData(
        isMyOrg ? API_ENDPOINTS?.UPDATE_MY_ORG : API_ENDPOINTS.UPDATE_ORG,
        generateFormData({
          id,
          name: organizationName,
          logo: logo,
          addressLine1: addressLine1,
          state: state,
          description: description,
          country: country,
          city: city,
          zipcode: zipcode,
          timezone: timezone,
          discountType,
          discountStartDate,
          discountEndDate,
          discountValue,
          deletelogo,
          isFeeWaived,
          resellerId,
          commission,
        })
      )

      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.updateOrganizationByIdLoader = false
    }
  }

  @action.bound
  clearOrganizationDiscountById = async (orgId) => {
    try {
      let response = await this.post(API_ENDPOINTS.DISCOUNT_CLEAR, {
        orgId: orgId,
      })

      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deleteOrganizationLogoById = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.UPDATE_MY_ORG, { id })
      if (response.status) {
        return [true, response.status]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  updateOrganizationByIdLocally = (values = {}) => {
    const id = values.id
    if (!id || !this.organizations) return

    this.organizations = (this.organizations || []).map((organization) => {
      if (organization.id == id) {
        return { ...organization, ...values }
      } else {
        return organization
      }
    })
  }

  @action.bound
  deleteOrganizationById = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_ORG, { id })
      if (response.status) {
        return [true, response.status]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  deleteOrganizationByIdLocally = (id) => {
    let organizations = this.organizations
    this.totalOrganizations = this.totalOrganizations - 1
    if (id && organizations) {
      this.organizations = (organizations || []).filter(
        (organization) => organization.id !== id
      )
    }
  }

  @action.bound
  changeOrganizationStatusById = async (orgId, status) => {
    try {
      let response = await this.post(API_ENDPOINTS.STATUS_CHANGE_ORG, {
        orgId,
        status,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getMyOrganization = async () => {
    try {
      let response = await this.get(API_ENDPOINTS.GET_MY_ORG)
      if (response.status) {
        this.myOrganizations = response.data || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch {
      this.myOrganizations = []
      return [false, undefined]
    }
  }

  @action.bound
  checkIfOrgExist = async (value) => {
    try {
      let respone = await this.post(API_ENDPOINTS.CHECK_EXIST_ORG, {
        name: value,
      })
      if (respone?.status) {
        return [true, respone?.data]
      }
      return [false, undefined]
    } catch {
      return [false, undefined]
    }
  }

  @action.bound
  geMyOrganizationDropdownById = async () => {
    try {
      this.myAllOrganizationsDropdownLoader = true
      let response = await this.get(API_ENDPOINTS.GET_DROPDOWN_MY_ORG_LIST)
      if (response?.status) {
        this.myAllOrganizationsDropdown = response.data?.myOrganization || []
        let cremember = (COOKIE_STOAGE.getItem('remember') || '') === true
        COOKIE_STOAGE.setItem(
          'organizationList',
          response.data?.myOrganization || [] || [],
          {
            ...(cremember ? { maxAge: COOKIE_SET_TIMER } : {}),
          }
        )
        return [true, response.data?.myOrganization || []]
      }
      return [false, undefined]
    } catch {
      this.myAllOrganizationsDropdown = []
      return [false, undefined]
    } finally {
      this.myAllOrganizationsDropdownLoader = false
    }
  }

  @action.bound
  getAllOrganizationDropdown = async (value = {}) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.GET_DROPDOWN_ALL_ORGANIZATION,
        { ...value }
      )
      if (response.status) {
        if (Object.keys(value)?.length === 0) {
          this.allOrganizationDropdownList = response?.data?.organizations
          return response?.data?.organizations
        }
        if (value?.isActive) {
          this.allOrganizationActiveDropdownList = response?.data?.organizations
          return response?.data?.organizations
        }
        this.allOrganizationInActiveDropdownList = response?.data?.organizations
        return response?.data?.organizations
      }
    } catch {
      this.allOrganizationDropdownList = []
      this.allOrganizationActiveDropdownList = []
      this.allOrganizationInActiveDropdownList = []
      return false
    }
  }

  @action.bound
  getAllCustomersDropdown = async (signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.GET_DROPDOWN_ALL_CUSTOMER,
        {},
        signal
      )
      if (response.status) {
        this.allCustomersDropdownList = response?.data
        return true
      }
    } catch {
      this.allCustomersDropdownList = []
      return false
    }
  }

  @action.bound
  extendNextBillingDate = async (value, orgId) => {
    const { date } = value
    try {
      let response = await this.post(API_ENDPOINTS.EXTEND_NEXT_BILLING_DATE, {
        date,
        orgId,
      })
      if (response.status) {
        return true
      }
    } catch {
      return false
    }
  }

  @action.bound
  resetStore = () => {
    this.currentOrganization = {}

    this.ordering = undefined
    this.orderingBy = undefined
    this.orgfSelectedDateChoice = undefined
    this.orgfAllFilters = {}

    this.orgSearchText = ''
    this.orgPageNo = DEFAULT_PAGE_START
    this.organizationsPageLimit = DEFAULT_PER_PAGE_RECORD
    this.organizations = []
    this.totalOrganizations = 0
    this.organizationsLoader = false
    this.updateOrganizationByIdLoader = false

    this.addOrganizationData = observable({
      organization: observable({}),
      users: observable([]),
    })
    this.deleteCustomerLoader = false

    this.editOrganizationData = observable({
      organization: observable({}),
      users: observable([]),
    })
    this.addOrganizationModalLoader = false

    this.allPosibileStatus = []
    this.myAllOrganizationsDropdownLoader = false
    this.myAllOrganizationsDropdown = []
    this.allOrganizationDropdownList = []
    this.allOrganizationActiveDropdownList = []
    this.allOrganizationInActiveDropdownList = []
    this.allOrgOwnersDropdown = []
    this.resellerDropdownOrganization = []
    this.allCustomersDropdownList = []

    this.myOrganizations = []
  }
}
